export default {
    "fr": {
        "My documents": "Mes documents",
        "No documents": "Aucun document pour le moment"
    },
    "en": {
        "My documents": "My documents",
        "No documents": "No documents"
    }
}
